// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"d2a8bd08","580":"e7c26ca5","683":"ebb64896","883":"54ea3a7b","946":"3d31f492"}[chunkId] + ".chunk.js";
};